var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSql = function SvgSql(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 17 17",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sql_svg__sql_svg__clip0_9315_35508)",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.164 5.566A1.333 1.333 0 019.497 6.9v2.666a1.333 1.333 0 11-2.666 0V6.9a1.333 1.333 0 011.333-1.334zm3.334 0V10.9h2.666m-5.334-.666l.667.667m-7.333-.668a.667.667 0 00.667.667h1.333a.667.667 0 00.667-.667V8.9a.667.667 0 00-.667-.667H2.831a.667.667 0 01-.667-.667V6.233a.667.667 0 01.667-.667h1.333a.667.667 0 01.667.667"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "sql_svg__sql_svg__clip0_9315_35508"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.164 .234)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgSql;